import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {SearchRequest} from '../models/search/search.request.model';
import {SearchResponse} from '../models/search/search.response.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService {


  constructor(private http: HttpClient) {
  }

  private SEARCH_URL: string = environment.BASE_URL + 'search';


  searchJobs(request: SearchRequest): Observable<SearchResponse> {
    return this.http.post<SearchResponse>(`${this.SEARCH_URL}`, request);
  }
}
